import { FlexLayout } from '@deity/falcon-ui';
import { H3 } from '@deity-io/portal-ui';
import CircularProgress from '@mui/material/CircularProgress';
import type { FC } from 'react';

interface LoadingPlaceholderProps {
  text?: string;
}
export const LoadingPlaceholder: FC<LoadingPlaceholderProps> = ({ text }) => (
  <FlexLayout alignItems="center" flexDirection="column">
    <CircularProgress color="inherit" sx={{ marginBottom: '24px' }} />
    <H3 fontWeight="bold">{text || 'Loading ...'}</H3>
  </FlexLayout>
);
